import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { IconAlfaLogo } from '@alfa-bank/site-icon/alfa-logo';
import { DataLayer } from '@alfa-bank/site-data-layer';
import { YandexSearchBar } from '@alfa-bank/site-yandex-search/search-bar-desktop';

import { ApplicationsButton } from '../components/applications-button';
import { MainHeader as Component } from '../main-header';
import type { TMainHeader, IDeps } from '../models';
import { BannerLink } from '../components/banner-link';
import { SegmentLink } from '../components/segment-link';
import { InternetBank } from '../components/internet-bank';
import { SearchIcon } from '../components/search-icon';
import { SubsectionLink } from '../components/subsection-link';
import { TopRow } from '../components/top-row';
import styles from '../styles/styles.css';

export const MainHeader = createWidget<IDeps, TMainHeader>({
    ApplicationsButton,
    BannerLink,
    DataLayer,
    IconAlfaLogo,
    styles,
    SubsectionLink,
    InternetBank,
    SearchIcon,
    SegmentLink,
    TopRow,
    Layout,
    YandexSearchBar,
})(Component);
